<template>
    <!-- <Vue3Signature v-if="mounted" ref="signature" :sigOption="state.option" :w="'1280px'" :h="'400px'"
        :disabled="state.disabled" @end="onStrokeEnd" class="bg-primary" /> -->
    <div class=" position-relative">
        <Vue3Signature class="signature-container" v-if="mounted" ref="signature" :sigOption="state.option" :w="'100%'"
            :h="'190px'" :disabled="state.disabled" @end="onStrokeEnd" />
        <div class="d-flex gap-2 align-item-center pad-actions">
            <span class="span-button" @click="clear">Clear</span>
            <span>|</span>
            <span class="span-button" @click="undo">Undo</span>
        </div>
    </div>

</template>

<script setup>
import { defineEmits, defineProps, onMounted, reactive, ref } from 'vue';

const props = defineProps({
    agreement: {
        type: Object,
        required: true,
        default: () => ({
            tos: false,
            signature: null,
            selfie: null,
            uploadedId: [],
            contract: null
        })
    }
});

const emit = defineEmits(['update:agreement']);

const state = reactive({
    option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
    },
    disabled: false
});

const mounted = ref(false);
const signature = ref(null);

onMounted(() => {
    mounted.value = true;
});

const updateSignature = (value) => {
    emit('update:agreement', {
        ...props.agreement,
        signature: value
    });
};

const onStrokeEnd = () => {
    setTimeout(() => {
        saveSignature();
    }, 100);
};

const saveSignature = () => {
    if (!signature.value) return;
    if (signature.value.isEmpty()) {
        updateSignature(null);
        return;
    }

    const dataURL = signature.value.save('image/jpeg');
    updateSignature(dataURL);
};

const clear = () => {
    signature.value.clear();
    updateSignature(null);
};

const undo = () => {
    signature.value.undo();
    if (signature.value.isEmpty()) {
        updateSignature(null);
    } else {
        saveSignature();
    }
};
</script>

<style scoped>
.signature-container {
    background-color: #f0f0f0;
    padding: 5px;
    border-radius: 8px;
}

.pad-actions {
    position: absolute;
    top: 20px;
    right: 30px;
}

.span-button {
    cursor: pointer;
}

.span-button:hover {
    text-decoration: underline;
    cursor: pointer;
    color: var(--primary);
}
</style>